export const shortcutStyles = () => ({
  shortcutDialogStyle: {
    '& .shortcutContent': {
      display: 'flex',
      '& .shortcutItems': {
        '&.left': {
          float: 'left',
          minWidth: 260,
          '& .shortcutKey': {
            width: 16,
            '&.longItem': {
              width: 30,
            },
          },
        },
        '&.right': {
          minWidth: 280,
          '& .shortcutKey': {
            width: 16,
          },
          '& .shortcutKey:nth-of-type(1)': {
            width: 30,
            '&.shortItem': {
              width: 20,
            },
          },
        },
        '& .shortcutItem': {
          lineHeight: '43px',
          '& .shortcutKey': {
            border: '1px solid #979797',
            borderRadius: 2,
            fontSize: 12,
            fontWeight: 500,
            textAlign: 'center',
            '&:first-child': {
              marginRight: 5,
            },
            '&:nth-last-child(2)': {
              marginLeft: 5,
              marginRight: 10,
            },
          },
          '& .item': {
            display: 'inline-block',
            lineHeight: '19px',
            '&.onlyOneItem': {
              marginRight: '35px !important',
              marginLeft: '0px !important',
            },
          },
        },
      },
    },
    '& .ms-Dialog-actionsRight': {
      textAlign: 'left !important',
      marginLeft: -4,
    },
  },
});
